import { render, staticRenderFns } from "./flex-wrap.vue?vue&type=template&id=e2263ecc&"
import script from "./flex-wrap.vue?vue&type=script&lang=js&"
export * from "./flex-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports